import { ArrowUpRight, ArrowRight } from "lucide-react";
import { scrollTo } from "@/lib/lenis";

const base =
  "group inline-flex items-center justify-center gap-2 px-6 py-3.5 text-[13px] font-semibold uppercase tracking-[0.14em] transition-[background-color,color,border-color,transform] duration-300 active:scale-[0.98]";

export const BuyButton = ({ href, children = "Przechodzę do zakupu", className = "", testId, variant = "red" }) => {
  const styles =
    variant === "red"
      ? "bg-red text-white hover:bg-redDark"
      : variant === "ink"
      ? "bg-ink text-white hover:bg-red"
      : variant === "outline"
      ? "border border-ink/25 text-ink hover:border-ink hover:bg-ink hover:text-white"
      : "bg-white text-ink hover:bg-red hover:text-white";
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testId} className={`${base} ${styles} ${className}`}>
      {children}
      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
    </a>
  );
};

export const AnchorButton = ({ to, children, className = "", testId, variant = "outline" }) => {
  const styles =
    variant === "outline"
      ? "border border-ink/25 text-ink hover:border-ink hover:bg-ink hover:text-white"
      : variant === "outline-light"
      ? "border border-white/35 text-white hover:border-white hover:bg-white hover:text-ink"
      : variant === "red"
      ? "bg-red text-white hover:bg-redDark"
      : "bg-ink text-white hover:bg-red";
  return (
    <a
      href={to}
      data-testid={testId}
      onClick={(e) => {
        e.preventDefault();
        scrollTo(to);
      }}
      className={`${base} ${styles} ${className}`}
    >
      {children}
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
    </a>
  );
};

export const TextLink = ({ href, children, testId, className = "" }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    className={`group inline-flex items-center gap-1.5 text-[13px] font-semibold text-ink underline-offset-4 hover:text-red hover:underline ${className}`}
  >
    {children}
    <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
  </a>
);
